var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{style:({ 'background-color': this.color, 'height': this.height, 'width': this.width, 'font-size': this.size }),attrs:{"id":"btn","to":this.route ? this.route : ''}},[_vm._v(" "+_vm._s(this.text))])}
var staticRenderFns = []

export { render, staticRenderFns }